import React, { useState } from "react";
import { useGlobal } from "reactn";
import Modal from "components/Modal";
import CustomInput from "components/CustomInput";
import ButtonSuccess from "components/Buttons/ButtonSuccess";
import { getUrl } from "@outplayed/riot-assets";
import { useQueryString, usePrevious } from "hooks/general-hooks";
import { useMutation } from "@apollo/client";
import { SET_PROFILE_CUSTOMIZATIONS } from "api/graphql/queries";
import { getRiotAssetsContext } from "@outplayed/riot-assets";

const ProfileSocialModal = (props) => {
  const { getChampionIdByName, getChampionSplashImg } = getRiotAssetsContext();
  const [isWebP] = useGlobal("isWebP");
  const { customizationData, summonerName, regionId, changeCustomizations, setIsModalOpen } = props;
  const [setProfileCustomizations, { data }] = useMutation(SET_PROFILE_CUSTOMIZATIONS);
  const [buttonText, setButtonText] = useState("Save Changes");
  const prevSearch = usePrevious(location.search);
  const prevPathname = usePrevious(location.pathname);
  const queryString = useQueryString();
  const prevProps = usePrevious(props);

  const prefixes = {
    twitchText: "http://twitch.tv/",
    youtubeText: "http://youtube.com/channel/",
    twitterText: "http://twitter.com/",
  };
  const [socialText, setSocialText] = useState({
    twitchText: customizationData.twitchLink,
    youtubeText: customizationData.youtubeLink,
    twitterText: customizationData.twitterLink,
  });

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const swapToBackgroundModal = () => {
    props.swapModal("backgroundModal");
  };

  const onInputChange = (fieldToChange, val) => {
    val = val.substring(prefixes[fieldToChange].length);
    if (val.indexOf("https://twitter.com") !== -1) {
      val = val.split("/")[3].split("?")[0];
    } else if (val.indexOf("twitch.tv/") !== -1) {
      val = val.split("/")[3];
    } else if (val.indexOf("youtube.com/channel") !== -1) {
      val = val.split("/")[4];
    }
    val = val.replace(/[^a-z0-9/_-]+/gi, "");
    val = val.substring(0, 50);
    setSocialText({
      ...socialText,
      [fieldToChange]: val,
    });
    setButtonText("Save Changes");
  };

  const editCustomizations = () => {
    const newCustomizations = {
      regionId: regionId,
      summonerName: summonerName,
      headerBg: customizationData.headerBg,
      youtubeLink: socialText.youtubeText,
      youtubeName: "",
      twitchLink: socialText.twitchText,
      twitchName: "",
      twitterLink: socialText.twitterText,
      twitterName: "",
    };
    const combinedCustomizations = changeCustomizations(newCustomizations);

    setProfileCustomizations({ variables: combinedCustomizations });
    setButtonText("Saved!");
    closeModal();
  };

  const headerChampionSplit = customizationData.headerBg.split("_");
  const championId = getChampionIdByName(headerChampionSplit[0]);
  const headerImg = getChampionSplashImg(championId, { splashId: headerChampionSplit[1], webp: isWebP });
  const twitchIcon = getUrl("lol/icons/social_twitch_icon.svg");
  const youtubeIcon = getUrl("lol/icons/social_youtube_icon.svg");
  const twitterIcon = getUrl("lol/icons/social_twitter_icon.svg");
  return (
    <Modal disableTooltip={true} isFixed={true} bDisableFooter={true} bModalOpen={true}>
      <div className="profile-customizations">
        <div className="background"></div>
        <div className="customizations-modal">
          <div className="social-modal">
            <div className="row header-row">
              <div className="header-text">Edit Profile</div>
              <img
                className="close-button"
                onClick={closeModal}
                src={"https://static.bigbrain.gg/assets/ugg/icons/X.svg"}
                alt="Close Button"
              />
            </div>
            <div className="bg-header-row-container row">
              <div
                className="background-header-row header-preview"
                style={{ backgroundImage: `url(${headerImg})` }}
                onClick={swapToBackgroundModal}
                data-summoner={summonerName.toLowerCase()}
                data-region={regionId}
              >
                <img className="choose-background-image" src={getUrl("lol/customizations/icons/choose-background-image.png")} />
                <div className="sbt">Choose Header</div>
              </div>
            </div>
            <div className="row sbt social-media-row-header-row ">Social Media</div>
            <div className="row icon-and-label-row">
              <img src={twitchIcon} className="icon" />
              <div className="inner-text">Twitch</div>
            </div>
            <div className="row">
              <CustomInput
                value={prefixes["twitchText"] + socialText.twitchText}
                error={""}
                onChange={(e) => onInputChange("twitchText", e.target.value)}
                placeholder="http://twitch.tv"
                type="text"
                tabIndex={1000}
                autoFocus
                style={{}}
              />
            </div>
            <div className="row icon-and-label-row">
              <img src={youtubeIcon} className="icon" />
              <div className="inner-text">YouTube</div>
            </div>
            <div className="row">
              <CustomInput
                value={prefixes["youtubeText"] + socialText.youtubeText}
                error={""}
                onChange={(e) => onInputChange("youtubeText", e.target.value)}
                placeholder="http://youtube.com/"
                type="text"
                tabIndex={1000}
                autoFocus
                style={{}}
              />
            </div>
            <div className="row icon-and-label-row">
              <img src={twitterIcon} className="icon" />
              <div className="inner-text">Twitter</div>
            </div>
            <div className="row">
              <CustomInput
                value={prefixes["twitterText"] + socialText.twitterText}
                error={""}
                onChange={(e) => onInputChange("twitterText", e.target.value)}
                placeholder="http://twitter.com"
                type="text"
                tabIndex={1000}
                autoFocus
                style={{}}
              />
            </div>
            <div className="row">
              <ButtonSuccess
                className="login-submit btn-light-blue save-button"
                label={buttonText}
                onClick={editCustomizations}
                bForceSubmitOnEnter={true}
                disable={buttonText === "Saved!"}
                style={buttonText === "Saved!" ? { background: "grey" } : {}}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ProfileSocialModal;
